<div class="mb-3" [class.has-error]="showError">
  <label *ngIf="props.label && props.hideLabel !== true" [attr.for]="id">
    {{ props.label }}
    <span *ngIf="props.required && props.hideRequiredMarker !== true">*</span>
  </label>
  <div>
    <ng-select [items]="items$ | async"
               bindLabel="header"
               bindValue="id"
               [formlyAttributes]="field"
               [placeholder]="field.props.label"
               [compareWith]="compareItems"
               [loading]="loading"
               [typeahead]="searchInput$"
               [clearable]="true"
               (open)="searchInput$.next('')"
               (clear)="onClear()"
               (change)="changeSelectedOption($event)"
               [(ngModel)]="selectedOption"
               typeToSearchText="Пожалуйста, введите 2 или более символов"
               i18n-typeToSearchText="@@AutocompleteTypeToSearchText"
    >
    </ng-select>
  </div>
  <div *ngIf="showError" class="invalid-feedback">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
  <small *ngIf="props.description" class="form-text text-muted">{{ props.description }}</small>
</div>
